<template>
  <b-modal ref="modal" title="Delete Integration" centered>
    Are you sure you want to delete this Integration?
    You cannot undo this action and it will result in all associated data being removed.
    <template #modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="float-left mr-1" @click="deleteIntegration">Submit</b-button>
        <b-button variant="outline-primary" class="float-left" @click="$refs.modal.hide()">
          Cancel
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import IntegrationsEventBus from '@/xvisor/bus/IntegrationsEventBus';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      deleteUrl: `/integrations/${this.id}`,
    };
  },
  methods: {
    deleteIntegration() {
      this.$http
        .delete(this.deleteUrl)
        .then(() => {
          this.$bvToast.toast('Successfully deleted integration', { variant: 'success' });
          this.$refs.modal.hide();
          IntegrationsEventBus.$emit('update');
        })
        .catch(() => {
          this.$bvToast.toast('Failed to delete integration', { variant: 'danger' });
        });
    },
  },
};
</script>
